export default {
	form: {
		required_error: 'Este campo é obrigatório',
		max_length_exceeded_error:
			'Este campo é longo demais (máximo {{length}} caracteres)'
	},
	legal: {
		copyright: 'Gerositus Sàrl - Todos os direitos reservados',
		i_consent: 'Eu concordo',
		agreement_title: 'Acordo',
		agreement_content:
			'Ao usar o Gerositus, você concorda com nossos <1>Termos e condições</1> e <2>Política de privacidade</2>.',
		agreement_terms_conditions: 'Termos e condições',
		agreement_privacy_policy: 'Política de privacidade',
	},
	navigation: {
		home: 'Início'
	},
	yes: 'Sim',
	no: 'Não',
	not_defined: 'Não definido',
	please_wait: 'Aguarde',
	search: 'Pesquisar',
	upgrade_required: 'Upgrade necessário',
	create_project_title: 'O que você deseja alcançar?',
	click_to_change: 'Clique para alterar',
	click_to_create_one: 'Clique <button>para criar</button>',
	no_goal: 'Sem meta',
	auth: {
		token_expiring_soon: 'Sua sessão expira em {{minutes}} minutos',
		token_expired:
			'Sua sessão expirou. Você será redirecionado para o login.',
		token_check_error: 'Erro ao verificar o token',
		session_expiring:
			'Sua sessão está prestes a expirar. Reconecte-se. Tempo restante: {{time}}'
	},
	bot: {
		placeholder: 'Digite sua pergunta aqui',
		security_notice: 'IA privada e isolada. As suas conversas permanecem confidenciais.'
	},
	tutorial: {
		button: 'Tutorial',
		exit_title: 'Sair do tutorial',
		exit_confirm: 'Tem certeza de que deseja sair do tutorial?'
	},
	subscription: {
		billing_monthly: 'Mensal',
		billing_yearly: 'Anual',
		billing_yearly_save: '(economize 20%)',
		choose_now: 'Escolher agora'
	},
	icons: {
		used: 'Usado',
		unused: 'Não usado'
	},
	theme: {
		selector: 'Seletor de tema',
		current_theme: 'Tema atual',
		change_theme: 'Alterar tema'
	},
	no_description: 'Sem descrição',
	situation_analysis: {
		title: 'Análise de situação',
		description:
			'Analisar automaticamente uma organização, empresa ou situação',
		organization_label: 'Organização / empresa',
		organization_placeholder: 'Nome da organização a analisar',
		subject_label: 'Assunto',
		subject_placeholder:
			'Assunto a analisar (pré-preenchido com o nome do projeto)',
		launch_analysis: 'Executar análise',
		analysis_in_progress: 'Análise em andamento…',
		complete_analysis: 'Concluir análise',
		waiting_analysis: 'Aguardando análise…',
		waiting_summary: 'Aguardando resumo…',
		waiting_stakes: 'Aguardando interesses…',
		waiting_risks: 'Aguardando riscos…',
		waiting_openings: 'Aguardando aberturas…',
		waiting_stakeholders: 'Aguardando partes interessadas…',
		context_title: 'Contexto geral',
		summary_title: 'Resumo',
		stakes_title: 'Interesses',
		risks_title: 'Riscos',
		openings_title: 'Aberturas',
		stakeholders_title: 'Partes interessadas',
		status: 'Status',
		likelihood: 'Probabilidade',
		impact: 'Impacto',
		stakeholder: {
			importance_label: 'Importância relativa',
			propensity_label: 'Propensão',
			engagement_label: 'Engajamento',
			importance_values: {
				low: 'Baixa',
				medium: 'Média',
				high: 'Alta'
			},
			propensity_values: {
				green: 'Favorável',
				neutral: 'Neutro',
				orange: 'Tenso',
				red: 'Adverso'
			},
			engagement_values: {
				inactive: 'Inativo',
				neutral: 'Neutro',
				low: 'Baixo',
				medium: 'Médio',
				high: 'Forte'
			},
			polarity_values: {
				positive: 'apoio',
				negative: 'oposição'
			}
		},
		risk_category_values: {
			operational: 'Operacional',
			strategic: 'Estratégico',
			existential: 'Existencial'
		}
	},
	ai_project_generation: {
		checkbox_label: 'Gerar conteúdo com IA',
		checkbox_tooltip:
			"Usa o título, a missão, a descrição e os cenários listados abaixo. A busca por IA pública só é lançada após sua validação («Criar projeto»).",
		title: 'Geração de projeto com IA',
		go_to_project: 'Ir ao projeto',
		create_project: 'Criar projeto',
		include_in_project_aria: 'Incluir este item no projeto',
		creation_modal_title: 'Criando itens',
		creation_progress_text: '{{current}} / {{total}} itens criados',
		error_title: 'Erro de geração',
		complete_title: 'Geração concluída',
		complete_description:
			'Seu projeto foi enriquecido com sucesso. A IA identificou partes interessadas, interesses, riscos e aberturas-chave.',
		summary_title: 'Resumo da análise',
		initializing_text:
			'Preparando análise profunda… Isso pode levar de 6 a 10 minutos.',
		include_in_project_tooltip:
			'Se marcado, o item será criado no projeto ao clicar em «Criar projeto».',
		language_code: 'pt',
		patience_with_scenarios:
			'A geração de cenários é complexa e pode levar alguns minutos. Obrigado pela paciência.',
		patience_no_scenarios:
			'A análise aprofundada pode levar alguns minutos. Obrigado pela paciência.',
		phases: {
			initializing: 'Iniciando',
			deep_research: 'Pesquisa',
			analyzing: 'Análise IA',
			stakeholders: 'Partes interessadas',
			stakes: 'Interesses',
			risks: 'Riscos',
			openings: 'Aberturas',
			summary: 'Resumo',
			fishbone: 'Plano de ação',
			entities: 'Entidades',
			scenarios: 'Cenários',
			completed: 'Concluído',
			error: 'Erro'
			},
		section_title: "Detalhes da geração IA",
		disclosure_public_title: "Para IA públicas",
		disclosure_public_sub: "Busca na web. Recebe apenas a previsualização neutra abaixo — sem intenção, sem objetivos.",
		disclosure_private_title: "IA privada e isolada",
		disclosure_private_sub: "Executada em um ambiente isolado. Sem retreinamento, sem envio de dados para fora. Processa o título, a missão, a descrição e os cenários.",
		zone_public: "Enviado a IA pública",
		zone_private: "Privado — não enviado a IA públicas",
		field_private_chip: "Privado e seguro",
		field_private_tooltip: "Processado por uma IA privada em um ambiente isolado. Sem retreinamento, sem envio de dados para fora.",
		preview_title: "Previsualização da busca",
		preview_refresh: "Regenerar a previsualização",
		preview_hint: "Reformulação neutra do seu tópico — sem rastro de intenção. É exatamente o que será enviado à busca pública — apenas após sua validação.",
		preview_placeholder: "Informe ao menos o título do projeto para gerar a previsualização.",
		launch_generation: "Iniciar geração",
		fishbone_source: 'Texto fonte',
		scenario_n: 'Cenário {{n}}',
		scenario_optimistic: 'Favorável',
		scenario_baseline: 'Provável',
		scenario_pessimistic: 'Desfavorável',
		scenario_pending: 'Pendente',
		scenario_triggers: 'Eventos desencadeadores',
		scenario_action_window: 'Janela de ação',
		scenario_detail: 'Análise detalhada',
		dismiss: 'Descartar sugestões da IA e criar projeto',
		save_pdf: 'Salvar como PDF',
		save_hint: 'Você pode salvar esta análise antes de entrar no projeto.',
		scenario_impacts: 'Impactos por entidade',
		data: {
			scenarios: 'Cenários prospectivos',
			fishbone: 'Plano de ação estratégico'
		}
	},
	scenario_elaboration: {
		title: 'Elaboração de cenário com IA',
		hypothesis: 'Hipótese',
		initializing: 'Iniciando análise…',
		error_title: 'Erro na elaboração',
		complete_title: 'Elaboração concluída',
		complete_description:
			'O cenário foi elaborado com sucesso. As alterações foram aplicadas.',
		analysis_preview: 'Análise preliminar',
		applied_changes: 'Alterações aplicadas',
		stakeholders_modified: 'parte(s) interessada(s) modificada(s)',
		stakes_modified: 'interesse(s) modificado(s)',
		risks_modified: 'risco(s)/abertura(s) modificados',
		indicators_modified: 'indicador(es) modificado(s)',
		new_elements: 'novos',
		steps: {
			started: 'Iniciando',
			started_desc: 'Iniciando análise…',
			fetching_project: 'Carregando projeto',
			fetching_project_desc: 'Carregando dados do projeto…',
			deep_research: 'Análise inicial',
			deep_research_desc: 'Análise situacional profunda…',
			ai_analysis: 'Análise IA',
			ai_analysis_desc: 'A IA analisa o impacto da hipótese…',
			reformatting: 'Formatação',
			reformatting_desc: 'Estruturando resultados…',
			processing_stakeholders: 'Partes interessadas',
			processing_stakeholders_desc: 'Calculando impactos nas partes…',
			processing_stakes: 'Interesses',
			processing_stakes_desc: 'Calculando impactos nos interesses…',
			processing_risks: 'Riscos',
			processing_risks_desc: 'Calculando impactos nos riscos…',
			processing_indicators: 'Indicadores',
			processing_indicators_desc: 'Calculando impactos nos indicadores…',
			completed: 'Concluído',
			completed_desc: 'Análise concluída com sucesso',
			error: 'Erro',
			error_desc: 'Ocorreu um erro'
		}
	}
};
